window.onload = function() {


    /**
     * selectorに入力された「全角数字」と「全角ハイフン」を半角に変更する
     */
    (function(selector = '[name="tel"]'){

        const inputElement = document.querySelector(selector);
        const inputHandler = (event) => {
            let value = inputElement.value;

            value = value.replace(/[０-９]/g, function(value) {
                return String.fromCharCode(parseInt(value.charCodeAt(0))-65248);
            });

            inputElement.value = value.replace(/[―ー－]/g, '-');
        };

        inputElement.addEventListener('blur', inputHandler);
        inputElement.addEventListener('change', inputHandler);
    })();


}